// Framework and third-party non-ui
import React, { useContext, useEffect, useRef } from "react";

// App components
import MapLoader from "./MapLoader";
import { MapContext } from "contexts/MapContext";

import { filterMapDataByTrailIds, turnOffHighlights } from "data/map";

// JSON & Styles
import { StyledMap } from "./Map-styled";

const Map = () => {
  const {
    ready,
    sidebarSelection,
    filteredFeatureList,
    advancedOptions,
    setContainer,
    mapView,
  } = useContext(MapContext);

  const mapRef = useRef();

  useEffect(() => {
    (async () => {
      let trailSelected;

      if (sidebarSelection && sidebarSelection[0] === "Trail") {
        trailSelected = sidebarSelection[3];
      }
      if (mapView && anyOptions() && filteredFeatureList.length) {
        let trailIds = filteredFeatureList.map(
          (e) => e.attributes["PRIMARY_TRAIL_ID"]
        );

        if (trailIds.length)
          filterMapDataByTrailIds(trailIds, mapView, trailSelected);
      } else if (mapView && (!anyOptions() || !filteredFeatureList.length)) {
        await turnOffHighlights(mapView, trailSelected);
      }
    })();
  }, [mapView, filteredFeatureList]);

  // useWatch(view, "stationary", debounce(handleMapExtentChanged, 500));

  const anyOptions = () => {
    return Object.entries(advancedOptions).some(([key, vals]) =>
      Object.values(vals).some((val) => val)
    );
  };

  useEffect(() => {
    mapRef.current && setContainer(mapRef.current);
  }, [mapRef, setContainer]);

  return (
    <>
      {!ready ? <MapLoader /> : null}
      <StyledMap ref={mapRef} data-testid="Map"></StyledMap>
    </>
  );
};

export default Map;
